import { render, staticRenderFns } from "./vcSelectCampaign.vue?vue&type=template&id=ae84ad20&"
import script from "./vcSelectCampaign.vue?vue&type=script&lang=js&"
export * from "./vcSelectCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports